import {
  AggregateDataverseChartDataSource,
  QueryAggregate,
  DateGrouping,
  ChartType,
} from '@powerportalspro/react-charts';
import { DataverseChart } from '@powerportalspro/react-fluent';
import { useT } from '@powerportalspro/react';
import { useMemo } from 'react';

// Reuses the Blazor demo's localization keys so both stacks share the
// JSON. Framework flattens to `components.<FullTypeName>.<key>`.
const STRINGS_BASE =
  'components.PowerPortalsPro.Demo.Client.Customizations.Pages.Charts.BarChart.BarChartTimeOfDayDemo';

// The opportunities by the hour of the day they were created, in two-hour steps, every day's
// folded together: a time-of-day profile. Dataverse can't group a date by the hour, so the chart
// reads each record's time, in the user's time zone, and adds them up itself.
export function BarChartTimeOfDaySample() {
  const t = useT();
  const source = useMemo(
    () =>
      new AggregateDataverseChartDataSource({
        tableName: 'opportunity',
        groupByColumn: 'createdon',
        groupByDateGrouping: DateGrouping.HourOfDay,
        groupByRangeSize: 2,
        aggregateColumn: 'opportunityid',
        aggregate: QueryAggregate.Count,
      }),
    [],
  );
  return <DataverseChart dataSource={source} type={ChartType.Bar} title={t(`${STRINGS_BASE}.chart-title`)} />;
}
